/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useState, useEffect, Fragment } from 'react';
import { useHistory, Link, useParams } from "react-router-dom";
import axios from 'axios';
import { AUTH_CONFIG } from './auth0-variables';
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux';
import { updateUserProfile, setAppState, toggleTheme } from '../actions'
import Cookies from 'universal-cookie';
import { setAuthTokens } from './tokenManager';

const blocks = () => css`
    .blocks {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
}

.block {
  --sz: 60px;
  --tX: 0;
  --animation: 700ms cubic-bezier(0.3, 0.5, 0.4, 0.9) infinite alternate-reverse;
  --hm: 4px;
  height: var(--sz);
  width: var(--sz);
  border-radius: 50%;
  transform: translateX(var(--tX));
  mix-blend-mode: normal;
  position: relative;
}

.orange {
  background: #1a71b9;
  margin-right: var(--hm);
  animation: attract-orange var(--animation);
  border-bottom-left-radius: 0px;
  z-index: 1;
}

.blue {
  background: rgba(108, 184, 244, 0.7);
  margin-left: var(--hm);
  animation: attract-blue var(--animation);
  z-index: 2;
}
.loading-text {
  font-size: 16px;
  color: #555; /* Starting dark gray color */
  animation: loading-fade 1.5s ease-in-out infinite;
  text-align: center;
  margin-top: 2rem;
}

@keyframes loading-fade {
  0%, 100% {
    color: #555; /* Darker gray */
  }
  50% {
    color: #ccc; /* Lighter gray */
  }
}

 @keyframes attract-orange {
    to {
      transform: translateX(calc(var(--sz) / 3)); /* Reduced movement */
    }
  }

  @keyframes attract-blue {
    to {
      transform: translateX(calc(var(--sz) / -3)); /* Reduced movement */
    }
  }
`

function Demo(props) {

    const dispatch = useDispatch()
    const history = useHistory();
    const { blueprintCode } = useParams();

    useEffect(() => {
    // read token from query string if present (e.g. /demo?token=...)
    const getQueryParam = (name) => {
      const params = new URLSearchParams(window.location.search);
      return params.get(name);
    };

    const demoToken = getQueryParam('token');

    const model = {
      Date: moment().format('MM/DD/YYYY HH:mm:ss'),
      BlueprintCode: blueprintCode || 'restaurant'
    };

    const url = AUTH_CONFIG.API_URL + "/api/auth/Demo";

    const config = {};
    if (demoToken) {
      config.headers = { 'X-Demo-Token': demoToken };
    }

    axios.post(url, model, config)
      .then((response) => {
        setAuthTokens({
          accessToken: response.data.token,
          refreshToken: response.data.refreshToken,
          expires: response.data.expires
        });
        localStorage.setItem('user_type', "1");

        axios.get(AUTH_CONFIG.API_URL + "/api/Account/GetAppState")
          .then((response) => {
            logInCallback(response.data, history)
          });

      })
      .catch((error) => {
        // functional component: avoid using this.setState
        console.error('Demo provisioning error', error?.response?.data || error.message || error);
      });
    }, [blueprintCode]);

    const logInCallback = (data, history) => {
        const store = window.store;
        dispatch(setAppState(data.clientViewModel));
        dispatch(updateUserProfile(data.userProfileModel));
        localStorage.setItem('user_type', data.userProfileModel.userType);

        const cookies = new Cookies();
        let t = cookies.get('theme');
        t = t ? t : "light";
        store.dispatch(toggleTheme(t));

        localStorage.setItem('last_facility', data.userProfileModel.lastFacilityId);


        history.push('/scheduler/overview');
    };


    return (
        <div className="flexcenter width100 height100">
            <div className="flexcolumn aligncenter justifycenter" css={blocks}>
                <div className="blocks">
                    <div className="block orange"></div>
                    <div className="block blue"></div>
                </div>
                <div className="loading-text">Loading...</div>
            </div>
            <style>
                {`
                .sidebar, nav{display:none;}
                `}
            </style>
            <div className="quickstart-bg"></div>
        </div>
    );
}

export default Demo;
